import { createReducer } from 'utils/helpers';
import { PurchaseOrdersActionTypes, IActions } from './PurchaseOrders.actions';
import { IPriceOverrideAuthorityDialogProperties } from 'components/common/PriceOverrideAuthorityDialog/PriceOverrideAuthorityDialog.properties';

export type IPriceOverrideDialogState<IApiType = any> = Omit<IPriceOverrideAuthorityDialogProperties<IApiType>, 'values' | 'resetForm' | 'onOk' | 'onCancel'>;
export interface IState {
    PurchaseOrder?: string;
    LineNumber?: number;
    SummaryPanelData?: any;
    ProcessPurchaseOrderDetails?: any;
    ReloadPurchaseOrder: boolean;
    IsChangeStatusDisabled: boolean;
    PreventChangeStatus: boolean;
}

export const initialState: IState = {
    PurchaseOrder: '',
    LineNumber: 0,
    SummaryPanelData: undefined,
    ProcessPurchaseOrderDetails: undefined,
    ReloadPurchaseOrder: false,
    IsChangeStatusDisabled: false,
    PreventChangeStatus: false
};

type IAction = (state: IState, payload: any) => IState;

type IActionMap = Record<PurchaseOrdersActionTypes, IAction>;

const actionMap: IActionMap = {
    [PurchaseOrdersActionTypes.setPurchaseOrder]: (state: IState, payload: IState['PurchaseOrder']): IState => ({ ...state, PurchaseOrder: payload }),
    [PurchaseOrdersActionTypes.setLineNumber]: (state: IState, payload: IState['LineNumber']): IState => ({ ...state, LineNumber: payload }),
    [PurchaseOrdersActionTypes.setSummaryPanelData]: (state: IState, payload: IState['SummaryPanelData']): IState => ({ ...state, SummaryPanelData: payload }),
    [PurchaseOrdersActionTypes.setProcessPurchaseOrderDetails]: (state: IState, payload: IState['ProcessPurchaseOrderDetails']): IState => ({ ...state, ProcessPurchaseOrderDetails: payload }),
    [PurchaseOrdersActionTypes.setReloadPurchaseOrder]: (state: IState, payload: IState['ReloadPurchaseOrder']): IState => ({ ...state, ReloadPurchaseOrder: payload }),
    [PurchaseOrdersActionTypes.setIsChangeStatusDisabled]: (state: IState, payload: IState['IsChangeStatusDisabled']): IState => ({ ...state, IsChangeStatusDisabled: payload }),
    [PurchaseOrdersActionTypes.setPreventChangeStatus]: (state: IState, payload: IState['PreventChangeStatus']): IState => ({ ...state, PreventChangeStatus: payload }),
};

export default createReducer<IActionMap, IState, IActions>(actionMap);
